import React, { useState, useEffect, Fragment } from "react";
import clsx from "clsx";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    bgColor?: string;
    textColor?: string;
    border?: string;
    padding?: string;
    rounded?: string;
    size?: string;
    className?: string;
    children: React.ReactNode;
}

const ThemeButton: React.FC<ButtonProps> = ({
    type = "button",
    bgColor = "bg-primaryColor",
    textColor = "text-white",
    border = "",
    padding = "px-4 py-2",
    rounded = "rounded-none",
    size = "text-base",
    className = "",
    children,
    ...props
}) => {
    return (
        <button
            type={type}
            className={clsx(
                "inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none",
                bgColor,
                textColor,
                border,
                padding,
                rounded,
                size,
                className
            )}
            {...props}
        >
            {children}
        </button>
    )
}

export default ThemeButton;